
const SYNC_PDFS = 'sync-pdfs';
const PDFS_STORE = 'pdfs-store';
const SYNC_NEW_PDFS = 'sync-new-pdfs';

export {
  SYNC_PDFS,
  PDFS_STORE,
  SYNC_NEW_PDFS
};
